module.exports = __webpack_public_path__ + "static/media/bell-slash.0ef96780.svg";